export default __webpack_public_path__ + "static/media/sky.cb9a4e26.svg";